import { Grid } from "@mui/material";
import React from "react";
import Logo from "./logo";
import PrimaryButton from "../ui/buttons/primaryButton";

function Header() {
  return (
    <Grid container>
      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        <Logo />
      </Grid>
      <Grid item xs={4}></Grid>
    </Grid>
  );
}

export default Header;
